export interface Resource {
  id: string;
  title: string;
  category: string;
  size: string;
  date: string;
  magnet: string;
  seeders: number;
  leechers: number;
  hot: number;
  description: string;
  tags: string[];
  fileCount: number;
}

export const resources: Resource[] = [
  {
    id: 'res-001',
    title: '流浪地球2 [4K HDR 杜比视界]',
    category: 'yingshi',
    size: '28.5 GB',
    date: '2026-08-05',
    magnet: 'magnet:?xt=urn:btih:a1b2c3d4e5f6a7b8c9d0e1f2a3b4c5d6e7f8a9b0',
    seeders: 15280,
    leechers: 2340,
    hot: 98,
    description: '<p>《流浪地球2》是由郭帆执导，吴京、李雪健、沙溢、宁理、王智、朱颜曼滋领衔主演的科幻灾难电影。该片以提出计划将建造1万座行星发动机的时代为故事背景，讲述了"太阳危机"即将来袭，世界陷入一片恐慌之中，万座行星发动机正在建造中，人类将面临末日灾难与生命存续的双重挑战故事。</p><p>本资源为4K HDR杜比视界版本，画质极佳，包含国语原声和多种字幕轨道。</p>',
    tags: ['4K', 'HDR', '杜比视界', '科幻', '国产'],
    fileCount: 3,
  },
  {
    id: 'res-002',
    title: '周杰伦 - 最伟大的作品 无损FLAC全集',
    category: 'yinyue',
    size: '1.8 GB',
    date: '2026-08-04',
    magnet: 'magnet:?xt=urn:btih:b2c3d4e5f6a7b8c9d0e1f2a3b4c5d6e7f8a9b0c1',
    seeders: 8960,
    leechers: 1205,
    hot: 95,
    description: '<p>周杰伦《最伟大的作品》完整专辑无损FLAC格式，包含全部12首曲目。专辑融合古典与流行元素，是周杰伦时隔多年后的又一力作。</p><p>曲目列表：Intro、最伟大的作品、还在流浪、说好不哭、红颜如霜、不爱我就拉倒、Mojito、错过的烟火、等你下课、粉色海洋、倒影、我是如此相信</p>',
    tags: ['无损', 'FLAC', '华语', '周杰伦', '专辑'],
    fileCount: 15,
  },
  {
    id: 'res-003',
    title: 'Adobe Creative Cloud 2025 全家桶中文版',
    category: 'ruanjian',
    size: '45.2 GB',
    date: '2026-08-05',
    magnet: 'magnet:?xt=urn:btih:c3d4e5f6a7b8c9d0e1f2a3b4c5d6e7f8a9b0c1d2',
    seeders: 6780,
    leechers: 3450,
    hot: 92,
    description: '<p>Adobe Creative Cloud 2025全家桶中文版，包含Photoshop、Illustrator、Premiere Pro、After Effects、InDesign等全套创意设计软件。</p><p>适用系统：Windows 10/11 64位、macOS 14+</p>',
    tags: ['Adobe', '设计', '全家桶', '中文版', '2025'],
    fileCount: 28,
  },
  {
    id: 'res-004',
    title: '三体全集 - 刘慈欣 精校版EPUB+MOBI+AZW3',
    category: 'dianzishu',
    size: '45.8 MB',
    date: '2026-08-03',
    magnet: 'magnet:?xt=urn:btih:d4e5f6a7b8c9d0e1f2a3b4c5d6e7f8a9b0c1d2e3',
    seeders: 12340,
    leechers: 890,
    hot: 96,
    description: '<p>《三体》是刘慈欣创作的系列长篇科幻小说，由《三体》《三体Ⅱ·黑暗森林》《三体Ⅲ·死神永生》组成。作品讲述了地球人类文明和三体文明的信息交流、生死搏杀及两个文明在宇宙中的兴衰历程。</p><p>本资源包含三体全集精校版，支持EPUB、MOBI、AZW3三种格式，适配各类电子书阅读器。</p>',
    tags: ['科幻', '刘慈欣', '三体', '精校', '多格式'],
    fileCount: 9,
  },
  {
    id: 'res-005',
    title: '艾尔登法环：黄金树幽影 完整版',
    category: 'youxi',
    size: '68.7 GB',
    date: '2026-08-05',
    magnet: 'magnet:?xt=urn:btih:e5f6a7b8c9d0e1f2a3b4c5d6e7f8a9b0c1d2e3f4',
    seeders: 11200,
    leechers: 4560,
    hot: 94,
    description: '<p>《艾尔登法环》是由FromSoftware开发、万代南梦宫娱乐发行的动作角色扮演游戏。本资源包含黄金树幽影DLC的完整版，体验全新的探索区域和挑战。</p><p>适用系统：Windows 10/11 64位，需要支持DirectX 12的显卡。</p>',
    tags: ['3A大作', '动作RPG', '宫崎英高', 'DLC', '开放世界'],
    fileCount: 12,
  },
  {
    id: 'res-006',
    title: '鬼灭之刃 全集 1080P中日双语字幕',
    category: 'dongman',
    size: '85.3 GB',
    date: '2026-08-04',
    magnet: 'magnet:?xt=urn:btih:f6a7b8c9d0e1f2a3b4c5d6e7f8a9b0c1d2e3f4a5',
    seeders: 14560,
    leechers: 2340,
    hot: 93,
    description: '<p>《鬼灭之刃》全集1080P高清资源，包含立志篇、无限列车篇、游郭篇、刀匠村篇全部内容，中日双语字幕。</p><p>该作讲述了少年灶门炭治郎为了寻找让变成鬼的妹妹祢豆子恢复为人类的方法，加入了"鬼杀队"踏上斩鬼之旅的故事。</p>',
    tags: ['动漫', '热血', '1080P', '双语', '全集'],
    fileCount: 63,
  },
  {
    id: 'res-007',
    title: 'BBC 地球脉动 第三季 4K HDR',
    category: 'jilupian',
    size: '52.4 GB',
    date: '2026-08-02',
    magnet: 'magnet:?xt=urn:btih:a7b8c9d0e1f2a3b4c5d6e7f8a9b0c1d2e3f4a5b6',
    seeders: 9870,
    leechers: 1670,
    hot: 90,
    description: '<p>BBC《地球脉动》第三季（Planet Earth III），大卫·爱登堡爵士倾情解说。4K HDR超高清画质，中英双语字幕。</p><p>本季继续探索地球上最壮丽的自然奇观，从深海到高山，从沙漠到极地，展现生命的奇迹。</p>',
    tags: ['BBC', '纪录片', '自然', '4K', 'HDR'],
    fileCount: 8,
  },
  {
    id: 'res-008',
    title: 'Python从入门到精通 全套视频教程',
    category: 'xuexi',
    size: '32.6 GB',
    date: '2026-08-05',
    magnet: 'magnet:?xt=urn:btih:b8c9d0e1f2a3b4c5d6e7f8a9b0c1d2e3f4a5b6c7',
    seeders: 7890,
    leechers: 2340,
    hot: 88,
    description: '<p>Python从入门到精通全套视频教程，涵盖Python基础、Web开发（Django/Flask）、数据分析（Pandas/NumPy）、机器学习（Scikit-learn/TensorFlow）等完整学习路径。</p><p>共计300+课时，适合零基础入门到进阶学习。</p>',
    tags: ['编程', 'Python', '教程', '全套', '视频'],
    fileCount: 156,
  },
  {
    id: 'res-009',
    title: '奥本海默 [IMAX版 4K蓝光原盘]',
    category: 'yingshi',
    size: '92.8 GB',
    date: '2026-08-01',
    magnet: 'magnet:?xt=urn:btih:c9d0e1f2a3b4c5d6e7f8a9b0c1d2e3f4a5b6c7d8',
    seeders: 18920,
    leechers: 5670,
    hot: 99,
    description: '<p>《奥本海默》是由克里斯托弗·诺兰执导，基里安·墨菲主演的传记电影。影片讲述了美国"原子弹之父"罗伯特·奥本海默在二战期间领导曼哈顿计划研制原子弹的故事。</p><p>本资源为IMAX版4K蓝光原盘，包含HDR10+和杜比全景声音轨。</p>',
    tags: ['诺兰', '传记', '4K蓝光', 'IMAX', '奥斯卡'],
    fileCount: 5,
  },
  {
    id: 'res-010',
    title: 'Taylor Swift - The Eras Tour 演唱会 4K',
    category: 'yinyue',
    size: '22.4 GB',
    date: '2026-08-03',
    magnet: 'magnet:?xt=urn:btih:d0e1f2a3b4c5d6e7f8a9b0c1d2e3f4a5b6c7d8e9',
    seeders: 10230,
    leechers: 1890,
    hot: 91,
    description: '<p>Taylor Swift "The Eras Tour" 时代巡回演唱会完整版4K超清资源，包含全场44首歌曲的精彩表演。</p><p>从《Fearless》到《Midnights》，横跨Taylor Swift全部音乐时代的视听盛宴。</p>',
    tags: ['Taylor Swift', '演唱会', '4K', '欧美', '现场'],
    fileCount: 3,
  },
  {
    id: 'res-011',
    title: 'Visual Studio 2025 Enterprise 正式版',
    category: 'ruanjian',
    size: '18.6 GB',
    date: '2026-08-04',
    magnet: 'magnet:?xt=urn:btih:e1f2a3b4c5d6e7f8a9b0c1d2e3f4a5b6c7d8e9f0',
    seeders: 5430,
    leechers: 2100,
    hot: 85,
    description: '<p>Microsoft Visual Studio 2025 Enterprise正式版，最强大的集成开发环境。支持C#、C++、Python、JavaScript等多种编程语言的开发调试。</p><p>包含AI辅助编程Copilot集成，大幅提升开发效率。</p>',
    tags: ['微软', 'IDE', '开发工具', '企业版', '2025'],
    fileCount: 7,
  },
  {
    id: 'res-012',
    title: '金庸全集 精校典藏版 EPUB',
    category: 'dianzishu',
    size: '128.5 MB',
    date: '2026-08-05',
    magnet: 'magnet:?xt=urn:btih:f2a3b4c5d6e7f8a9b0c1d2e3f4a5b6c7d8e9f0a1',
    seeders: 15670,
    leechers: 1230,
    hot: 97,
    description: '<p>金庸先生全部武侠小说精校典藏版，包含"飞雪连天射白鹿，笑书神侠倚碧鸳"全部15部作品。</p><p>精校排版，EPUB格式，完美适配Kindle、iPad、手机等设备阅读。</p>',
    tags: ['金庸', '武侠', '全集', '精校', 'EPUB'],
    fileCount: 36,
  },
  {
    id: 'res-013',
    title: '塞尔达传说：王国之泪 中文版',
    category: 'youxi',
    size: '16.2 GB',
    date: '2026-08-02',
    magnet: 'magnet:?xt=urn:btih:a3b4c5d6e7f8a9b0c1d2e3f4a5b6c7d8e9f0a1b2',
    seeders: 13450,
    leechers: 3450,
    hot: 95,
    description: '<p>《塞尔达传说：王国之泪》是任天堂开发的开放世界动作冒险游戏。在天空、地面和地下三个维度展开全新的冒险。</p><p>中文版完整资源，包含全部DLC内容。</p>',
    tags: ['任天堂', '开放世界', '冒险', '中文', 'Switch'],
    fileCount: 4,
  },
  {
    id: 'res-014',
    title: '进击的巨人 最终季 完结篇 1080P',
    category: 'dongman',
    size: '48.6 GB',
    date: '2026-08-01',
    magnet: 'magnet:?xt=urn:btih:b4c5d6e7f8a9b0c1d2e3f4a5b6c7d8e9f0a1b2c3',
    seeders: 16780,
    leechers: 2890,
    hot: 94,
    description: '<p>《进击的巨人》最终季完结篇，包含前后篇全部内容。1080P高清画质，中文字幕。</p><p>巨人的真相终于揭晓，艾伦的选择将决定人类的命运。史诗级动画的完美收官。</p>',
    tags: ['进击的巨人', '最终季', '1080P', '热血', '完结'],
    fileCount: 12,
  },
  {
    id: 'res-015',
    title: '国家地理 经典纪录片合集 1080P',
    category: 'jilupian',
    size: '156.3 GB',
    date: '2026-08-03',
    magnet: 'magnet:?xt=urn:btih:c5d6e7f8a9b0c1d2e3f4a5b6c7d8e9f0a1b2c3d4',
    seeders: 8760,
    leechers: 3450,
    hot: 87,
    description: '<p>国家地理频道经典纪录片合集，包含《宇宙时空之旅》《火星时代》《海洋探秘》《伟大工程巡礼》等50余部经典纪录片。</p><p>1080P高清画质，中英双语字幕。</p>',
    tags: ['国家地理', '纪录片', '合集', '1080P', '双语'],
    fileCount: 87,
  },
  {
    id: 'res-016',
    title: '斯坦福大学 CS229 机器学习 完整课程',
    category: 'xuexi',
    size: '28.4 GB',
    date: '2026-08-04',
    magnet: 'magnet:?xt=urn:btih:d6e7f8a9b0c1d2e3f4a5b6c7d8e9f0a1b2c3d4e5',
    seeders: 6540,
    leechers: 1670,
    hot: 86,
    description: '<p>斯坦福大学CS229机器学习课程，由吴恩达（Andrew Ng）教授主讲。完整视频+课件+作业+答案。</p><p>涵盖监督学习、无监督学习、深度学习等核心机器学习算法原理与实现。</p>',
    tags: ['机器学习', '斯坦福', '吴恩达', 'AI', '课程'],
    fileCount: 48,
  },
];

export function getResourcesByCategory(category: string): Resource[] {
  return resources.filter((r) => r.category === category);
}

export function getResourceById(id: string): Resource | undefined {
  return resources.find((r) => r.id === id);
}

export function getRelatedResources(resource: Resource, limit: number = 6): Resource[] {
  const sameCategory = resources.filter(
    (r) => r.category === resource.category && r.id !== resource.id
  );
  return sameCategory.slice(0, limit);
}

export function searchResources(query: string): Resource[] {
  const q = query.toLowerCase();
  return resources.filter(
    (r) =>
      r.title.toLowerCase().includes(q) ||
      r.tags.some((t) => t.toLowerCase().includes(q)) ||
      r.description.toLowerCase().includes(q)
  );
}

export function getHotResources(limit: number = 8): Resource[] {
  return [...resources].sort((a, b) => b.hot - a.hot).slice(0, limit);
}

export function getLatestResources(limit: number = 12): Resource[] {
  return [...resources].sort(
    (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
  ).slice(0, limit);
}